//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export const PROMOTED_POSTS_BUDGET_ACTIONS = {
  CLEAR_PROMOTED_POSTS_BUDGET_STATE: 'CLEAR_PROMOTED_POSTS_BUDGET_STATE',
  UPDATE_BUDGET: 'UPDATE_BUDGET',
  UPDATE_DURATION: 'UPDATE_DURATION',
};
